"use client";

import type { AddFilter } from "@/lib/host-panel/catalog-types";
import type { AddFilterOption } from "@/lib/host-panel/catalog-scope";
import { CatalogChip } from "./catalog-filter-chip";
import { CatalogChipTrack, CatalogFilterRow } from "./catalog-filter-row";

/**
 * The "O que exibir" line of the filter block, in the add scope (handoff v2 §6.2): all pieces,
 * the ones already on the list, the ones not yet. A single choice, hence `radiogroup`. The list
 * arrives already filtered by count, and the label counts what it offers.
 */
export function AddFilterPills({
  options,
  value,
  onChange,
}: {
  options: readonly AddFilterOption[];
  value: AddFilter;
  onChange: (next: AddFilter) => void;
}) {
  return (
    <CatalogFilterRow label="O que exibir" count={`(${options.length})`} labelId="catalogo-o-que-exibir">
      <CatalogChipTrack role="radiogroup" aria-labelledby="catalogo-o-que-exibir">
        {options.map((option) => {
          const isActive = option.value === value;

          return (
            <CatalogChip
              key={option.value}
              role="radio"
              aria-checked={isActive}
              label={option.label}
              count={String(option.count)}
              isActive={isActive}
              onClick={() => onChange(option.value)}
            />
          );
        })}
      </CatalogChipTrack>
    </CatalogFilterRow>
  );
}
